import { currencyActions } from './slice';
import { CurrencyType } from './stateType';

export const fetchCurrency = currencyActions.fetchCurrency as () => void;

export const updateCurrency = currencyActions.updateCurrency as (payload: {
  factors: CurrencyType[];
  fy: string;
}) => void;

export const changeSelectedFy = currencyActions.changeSelectedFy as (
  payload: string,
) => void;
